// @Version: 1.0.0
export enum PARAMETER {
   BLANK = "_blank"
}